import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
	error: {
		padding: '20px', 
		maxWidth: '600px', 
		textAlign: 'center'
  	},
	errormessage: {
		color: theme.palette.error.main
	},
	button: {
		backgroundColor: '#0066cc',
		color: 'white',
		border: 'none',
		padding: '10px 15px',
		borderRadius: '5px',
		cursor: 'pointer',
		marginTop: '20px',
		marginRight: '50px'
	},
	loginbutton: {
		justifyContent: 'center',
		marginTop: '30px',
	},
	logout: {
		background: 'none !important',
		border: 'none',
		padding: '0 !important',
		textDecoration: 'underline',
		cursor: 'pointer',
		textTransform: "none",
		lineHeight: '1 !important',
		marginLeft: theme.spacing(.5),
	},
	logoutmessage: {
		marginTop: theme.spacing(2),
	}
}));